<script>
import cloneDeep from "lodash/cloneDeep";

export default {
  data() {
    return {
      typeSource: [
        {
          name: "中心刺激",
          type: "centralFixation"
        },
        {
          name: "旁中心刺激",
          type: "ecCentricFixation"
        },
        {
          name: "眼球震颤",
          type: "nystagmus"
        }
      ],
      type: "centralFixation",

      modelLevel: undefined,
      dynamicValidateForm: {
        domains: []
      },
      tempFormData: [],
      modelList: [],
      activeModel: undefined,
      allModelList: {
        nystagmus: [],
        ecCentricFixation: [],
        centralFixation: []
      },
      modelConfig: undefined,
      defaultConfig: undefined,
      activeModelData: {
        layout: undefined,
        weight: undefined
      }
    };
  },
  // computed: {
  //   hasDiff() {
  //     const oldValue = this.modelList.filter(
  //       o => o.modeId === this.activeModel
  //     )[0];
  //     const newValue = this.activeModelData;
  //     console.log(oldValue, newValue);
  //     if (oldValue.weight !== newValue.weight || oldValue.layout !== newValue.lay) {
  //       return false;
  //     } else {
  //       return true;
  //     }
  //   }
  // },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      const result = await this.$http.getStimulusModeList();
      if (result && result.data) {
        this.allModelList = result.data;
        this.modelList = result.data[this.type];
        if (this.activeModel) {
          this.activeModelData.layout =
            this.modelList.filter(o => o.modeId === this.activeModel)[0]
              .layout || undefined;
          this.activeModelData.weight =
            this.modelList.filter(o => o.modeId === this.activeModel)[0]
              .weight || undefined;
        } else {
          this.activeModel = this.modelList[0].modeId;
          this.activeModelData.layout = this.modelList[0].layout || undefined;
          this.activeModelData.weight = this.modelList[0].weight || undefined;
        }
      }
    },
    onSelectModel(value) {
      const activeMode = this.modelList.filter(o => o.modeId === value);
      if (activeMode && activeMode[0]) {
        this.activeModelData.layout = activeMode[0].layout || undefined;
        this.activeModelData.weight = activeMode[0].weight || undefined;
      } else {
        this.activeModelData.layout = undefined;
        this.activeModelData.weight = undefined;
      }
    },
    onSelectModelType(type) {
      if (this.allModelList && this.allModelList[type]) {
        this.modelList = this.allModelList[type];
        this.activeModel = this.modelList[0].modeId;
        this.activeModelData.layout = this.modelList[0].layout || undefined;
        this.activeModelData.weight = this.modelList[0].weight || undefined;
      }
    },
    async onSaveResult() {
      if (this.activeModelData.weight == 0) {
        const data = {
          modeId: this.activeModel,
          layout: null,
          weight: null
        };
        const result = await this.$http.updateStimulusModeConfigById(data);
        if (result) {
          this.$message.success("保存成功!");
        }
        this.loadData();
      } else if (this.activeModelData.weight && this.activeModelData.layout) {
        const data = {
          modeId: this.activeModel,
          layout: this.activeModelData.layout,
          weight: this.activeModelData.weight
        };
        const result = await this.$http.updateStimulusModeConfigById(data);
        if (result) {
          this.$message.success("保存成功!");
        }
        this.loadData();
      } else {
        this.$message.success("请先填写权重和位置!");
      }
    }
  }
};
</script>
<template>
  <div class="stimulusConfig">
    <el-row :gutter="24" class="gameSearchForm">
      <el-col :span="24" class="colStyle">
        <span class="searchTitle" style="vertical-align: top;">刺激模式：</span>
        <div class="radioView">
          <span
            v-for="typeInfo in typeSource"
            :key="typeInfo.type + typeInfo.name"
            class="radioCell"
          >
            <el-radio
              v-model="type"
              @change="onSelectModelType"
              :label="typeInfo.type"
            >{{typeInfo.name}}</el-radio>
          </span>
        </div>
      </el-col>
      <el-col :span="12" class="colStyle">
        <span class="searchTitle">刺激背景：</span>
        <span>
          <el-select
            size="medium"
            v-model="activeModel"
            @change="onSelectModel"
            class="selectInputStyle"
          >
            <el-option
              v-for="(model, index) in modelList"
              :key="index + '_modelName'"
              :label="model.name"
              :value="model.modeId"
            />
          </el-select>
        </span>
      </el-col>
    </el-row>
    <div class="parameterView">
      <el-row :gutter="24" class="parameterTitleView">
        <el-col :span="24">
          <span class="parameterTitle">参数配置</span>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="parameterCellView">
        <el-col :span="24">
          <span class="paramsLable">权重设置：</span>
          <el-input-number v-model="activeModelData.weight" :min="0" :max="10" label="权重"></el-input-number>
        </el-col>
        <el-col :span="24">
          <span class="paramsLable">覆盖区域：</span>
          <el-radio-group v-model="activeModelData.layout">
            <el-radio label="CENTRAL">中心</el-radio>
            <el-radio label="TILE">满屏</el-radio>
          </el-radio-group>
        </el-col>
        <el-col :span="24">
          <div class="add-mode">
            <el-button type="primary" @click="onSaveResult">提交</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.stimulusConfig {
  padding-left: 30px;
  padding-top: 15px;
  .gameSearchForm {
    margin: 0px 0px 10px !important;
    color: rgba(89, 94, 122, 1);
    // width: 00px;
    .colStyle {
      padding: 0 !important;
    }
    .selectInputStyle {
      width: 200px;
    }
    .searchTitle {
      padding-right: 10px;
      display: inline-block;
    }
    .radioView {
      width: 75%;
      display: inline-block;
    }
    .radioCell {
      width: 140px;
      margin-bottom: 12px;
      display: inline-block;
    }
  }
  .parameterView {
    border: 1px solid #d5dae0;
    border-radius: 4px;
    width: 95%;
    .parameterTitleView {
      margin: 0px !important;
      background-color: #f2f4f6;
      height: 44px;

      .parameterTitle {
        display: inline-block;
        line-height: 40px;
        font-size: 14px;
        color: rgba(34, 39, 46, 1);
      }
    }
    .paramsLable {
      display: inline-block;
      line-height: 40px;
      font-size: 14px;
      color: rgba(34, 39, 46, 1);
      width: 100px;
    }
    .parameterCellView {
      margin: 0px 0px 10px !important;
      min-height: 140px;
      padding: 10px;

      .parameterCellForm {
        padding-left: 12px;
        .parameterFormItem {
          margin-top: 10px;
        }
      }
      .domainsInput {
        width: 100px;
      }
      .lableView {
        display: inline-block;
        width: 40px;
        margin: auto 5px;
        color: rgba(93, 93, 93, 1);
      }
      .removeIconButton {
        border: none;
      }
    }
    .el-row {
      .configItemName {
        display: inline-block;
        width: 90px;
      }

      .bg-input-suffix {
        margin: 12px 0px;

        .bg-input {
          display: inline-block;
          height: 32px;
          width: 100px;
          padding: 0 5px;
        }

        .bg-photo-input {
          width: 515px;
          display: inline-block;
          height: 32px;

          padding: 0 5px;
        }

        .bg-text-button {
          display: inline-block;
        }

        .switch-bg {
          padding: 0 15px;
        }
      }

      .add-mode {
        text-align: center;
      }

      .operationBtn {
        align-items: center;
        display: flex;
        margin-left: 20px;
        color: #00adc7;
        cursor: pointer;

        > i {
          margin-right: 10px;
          font-size: 16px;
          font-weight: 500;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bgConfig/stimulusConfig.vue